import axios from 'axios';
import {
  GCPBillingDataResponse,
  GCPBillingListQuery,
  ResendGCPBillingInvoiceResponse,
} from './types';

export const fetchGCPBillingData = async (
  params: GCPBillingListQuery
): Promise<GCPBillingDataResponse> => {
  const { data } = await axios.get<GCPBillingDataResponse>(
    `${process.env.REACT_APP_BILLING_SERVICE}/gcp-billing-data`,
    { params }
  );
  return data;
};

export const resendGCPBillingInvoice = async (
  id: string
): Promise<ResendGCPBillingInvoiceResponse> => {
  const { data } = await axios.post<ResendGCPBillingInvoiceResponse>(
    `${
      process.env.REACT_APP_BILLING_SERVICE
    }/gcp-billing-data/${encodeURIComponent(id)}/resend-invoice`
  );
  return data;
};
